<template>
    <div class="main">
        <ul>
            <router-link v-for="(item,index) in nav" :key="index" :to="item.path" tag="li">
                <img :src="item.src" alt="">
                <p>{{item.name}}</p>
            </router-link>
        </ul>
    </div>
</template>
<script>
export default {
    data(){
        return{
            name:'',
            school:'',
            sexName:'',
            parameter:'',
            nav: [
                { name: '学生信息', idx: '0', path: '/parent/main/studentMessage',src:'/imgs/studyPlan/icon_01.png', src2:'/imgs/studyPlan/icon_h_01.png' },
                { name: '规划内容', idx: '1', path: '/parent/main/planningContent',src:'/imgs/studyPlan/icon_02.png',src2:'/imgs/studyPlan/icon_h_02.png' },
                { name: '计划执行', idx: '2', path: '/parent/main/implement/targetsplit',src:'/imgs/studyPlan/icon_03.png',src2:'/imgs/studyPlan/icon_h_03.png' },
                { name: '咨询记录', idx: '3', path: '/parent/main/consultationRecord',src:'/imgs/studyPlan/icon_04.png',src2:'/imgs/studyPlan/icon_h_04.png' },
                { name: '数据分析', idx: '4', path: '/parent/main/dataAnalysis/grade',src:'/imgs/studyPlan/icon_05.png',src2:'/imgs/studyPlan/icon_h_05.png' },
                { name: '成长档案', idx: '5', path: '/parent/main/growthFile',src:'/imgs/studyPlan/icon_06.png',src2:'/imgs/studyPlan/icon_h_06.png' },
            ],
          query:''
        }
    },
    methods:{},
    mounted(){},
}
</script>
<style scoped lang="less">
.main{
    background-color: #fff;
    padding-top: 40px;
    ul {
        width: 800px;
        display: flex;
        flex-wrap: wrap;
        margin: 0 auto;
        justify-content: space-between;
        li {
            box-sizing: border-box;
            padding: 27px;
            text-align: center;
            width: 206px;
            height: 180px;
            box-shadow: 0px 0px 5px 2px #EBF3FE;
            margin-bottom: 40px;
            cursor: pointer;
            img {
                margin-bottom: 30px;
            }
            p {
                font-size: 16px;
                color: #585858;
            }
        }
    }
}
</style>